import { RoutePath } from '@/core/router';
import { useUpdateLastAccess } from '@/modules/Users/queries';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoadingPage } from '../LoadingPage';

const SESSION_UPDATED_KEY = 'lastAccessUpdated';

export const OAuthCallback = () => {
  const { mutate: updateLastAccess } = useUpdateLastAccess();
  const navigate = useNavigate();

  useEffect(() => {
    if (!sessionStorage.getItem(SESSION_UPDATED_KEY)) {
      updateLastAccess(undefined, {
        onSettled: () => {
          navigate(RoutePath.home(), {
            replace: true,
          });
        },
      });
      sessionStorage.setItem(SESSION_UPDATED_KEY, 'true');
      return;
    } else {
      navigate(RoutePath.home(), {
        replace: true,
      });
    }
  }, [navigate, updateLastAccess]);

  return <LoadingPage />;
};
